import './component.scss'

// 説明展開機能
function initializeDescriptionToggle() {
  const moreButtons = document.querySelectorAll('.js-top-reform-example-card__more-button');

  moreButtons.forEach(button => {
    const description = button.closest('.top-reform-example-card__description-container').querySelector('.js-top-reform-example-card__description');

    // line-clampを一時的に解除してテキストの高さを測定
    description.style.webkitLineClamp = 'none';
    description.style.lineClamp = 'none';
    description.style.overflow = 'visible';

    // DOM更新を待つ
    requestAnimationFrame(() => {
      const fullHeight = description.scrollHeight;

      // line-clampを復元
      description.style.webkitLineClamp = '3';
      description.style.lineClamp = '3';
      description.style.overflow = 'hidden';

      // DOM更新を再度待つ
      requestAnimationFrame(() => {
        const clampedHeight = description.offsetHeight;

        // 3行以下の場合は「もっと見る」ボタンを非表示にする
        if (fullHeight <= clampedHeight + 5) { // 5pxのマージンを追加
          button.classList.add('hidden');
          return;
        }
      });
    });

    // ボタンをクリックした時はカードのリンク先に遷移する
    button.addEventListener('click', function(e) {
      e.stopPropagation();
      window.location.href = button.closest('.top-reform-example-card').href;
    });
  });
}

window.addEventListener('load', function () {
  // 説明展開機能を初期化
  initializeDescriptionToggle();
});
